import {
  Component,
  Input,
  HostBinding,
  Renderer2,
  ElementRef,
} from '@angular/core';
import { toNumber } from '../util';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'ellipsis',
  template: `<ng-content></ng-content>`,
  // tslint:disable-next-line:use-host-property-decorator
  host: { '[class.ad-ellipsis]': 'true' },
})
export class EllipsisComponent {
  /** å¨æç§è¡æ°æªåä¸æå¤§çè¡æ°ï¼è¶è¿åæªåçç¥ */
  @Input()
  @HostBinding('style.-webkit-line-clamp')
  get lines() {
    return this._lines;
  }
  set lines(value: any) {
    this._lines = toNumber(value);
  }
  private _lines = 3;

  constructor(el: ElementRef, render: Renderer2) {
    render.setStyle(el.nativeElement, '-webkit-box-orient', 'vertical');
  }
}
